import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import MagazineArticleTemplate from '../components/MagazineArticleTemplate';
import { getArticle } from '../data/magazine';
import { findShortRouteByPath } from '../data/seoShortRoutes';

/**
 * <SeoShortRoute /> — page proxy pour les slugs SEO courts.
 *
 * Exemple : `/casque-moto-ece-22-06` rend l'article `bien-choisir-casque-moto`
 * mais avec une URL canonique sur le slug court (mots-clés cibles).
 *
 * Si la route ou l'article est introuvable → fallback sur /magazine.
 */
export default function SeoShortRoute() {
  const { pathname } = useLocation();
  const route = findShortRouteByPath(pathname);

  if (!route) return <Navigate to="/magazine" replace />;

  const article = getArticle(route.slug);
  if (!article) return <Navigate to="/magazine" replace />;

  return (
    <MagazineArticleTemplate
      article={article}
      pathOverride={route.path}
    />
  );
}
